import { useId } from "react";
import { Link } from "react-router-dom";

import type { InboxGroup } from "../../../api/types";
import { Breadcrumb } from "../../../ui/Breadcrumb";
import { Card } from "../../../ui/Card";
import { Pill } from "../../../ui/Pill";
import { plural } from "../shared/format";
import { InboxEntryRow } from "./InboxEntryRow";

interface InboxGroupViewProps {
  group: InboxGroup;
  pointedId: string | null;
}

/** The elements that wait on one item, with the item's family breadcrumb and a link to its live map (DEC-1016-52). */
export function InboxGroupView({ group, pointedId }: InboxGroupViewProps) {
  const titleId = useId();
  const item = group.item;
  return (
    <Card className="ra-group" aria-labelledby={titleId}>
      <header className="ra-group__head">
        {group.breadcrumb.length > 0 && <Breadcrumb crumbs={group.breadcrumb} />}
        <div className="ra-group__title row">
          <h2 id={titleId}>{item ? item.name : "Elements that belong to no single item"}</h2>
          {group.is_connection && <Pill>Connection</Pill>}
          <span className="muted">{plural(group.entries.length, "card")}</span>
          {item && (
            <Link to={`/items/${encodeURIComponent(item.element_id)}/map`} className="ra-group__map">
              Open its live map
            </Link>
          )}
        </div>
      </header>
      <ul className="ra-entries">
        {group.entries.map((entry) => (
          <InboxEntryRow key={entry.element.id} entry={entry} pointed={pointedId === entry.element.id} />
        ))}
      </ul>
    </Card>
  );
}
